import Messages from "./comment.png";

import Conversions from './conversion.png';

import Likes from './heart.png';

import Interaction from './interaction.png';

import LeadGeneration from './lead-generation.png';

import Traffic from './traffic.png';

import GoogleLogo from './google-logo.png';

import FacebookLogo from './fb-logo.png';

import Impressions from './impressions.png';

import Reach from './reach.png';

import MetaLogo from './meta.png'


const Icons = {
    Messages,
    Conversions,
    Likes,
    Interaction,
    LeadGeneration,
    Traffic,
    GoogleLogo,
    FacebookLogo,
    Impressions,
    Reach,
    MetaLogo
}

export default Icons;